import https from "../../axios";
import { BaseResponse } from "../../db/response";
import normalizeBaseResponse from "../../utils/responseHandler";
import errorHandler from "../../utils/errorHandler";

interface LoginAnotherWayParams {
  emailOrPhone: string;
}

export const loginAnotherWayApi = async (
  params: LoginAnotherWayParams,
): Promise<BaseResponse> => {
  try {
    const response = await https.post("/v1/auth/login-another-way", params);
    return normalizeBaseResponse(response.data);
  } catch (error) {
    return errorHandler(error);
  }
};
